import {
  LOAD_SINGLE_NOTIFICATION_FAIL,
  LOAD_SINGLE_NOTIFICATION_OK,
  LOAD_SINGLE_NOTIFICATION_REQUESTED,
  SINGLE_NOTIFICATION_MARK_AS_READ,
} from "actions/singleNotifications";

const INITIAL_STATE = {
  messages: [],
};

export function singleNotificationsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOAD_SINGLE_NOTIFICATION_REQUESTED:
      return {
        ...state,
      };

    case LOAD_SINGLE_NOTIFICATION_OK:
      return {
        ...state,
        messages: action.messages,
      };

    case LOAD_SINGLE_NOTIFICATION_FAIL:
      return {
        ...state,
      };

    case SINGLE_NOTIFICATION_MARK_AS_READ:
      return {
        ...state,
        messages: state.messages.map((message) => {
          return message.id === action.message.id ? action.message : message;
        }),
      };

    default:
      return state;
  }
}
